import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { AnimatePresence } from "framer-motion";
import Home from "@/pages/Home";
import Changelog from "@/pages/Changelog";
import PageTransition from "@/components/site/PageTransition";
import IntroCurtain from "@/components/site/IntroCurtain";

function AnimatedRoutes() {
  const location = useLocation();
  return (
    <AnimatePresence mode="wait" initial={false}>
      <PageTransition key={location.pathname}>
        <Routes location={location} key={location.pathname}>
          <Route path="/" element={<Home />} />
          <Route path="/changelog" element={<Changelog />} />
        </Routes>
      </PageTransition>
    </AnimatePresence>
  );
}

function App() {
  const [showIntro, setShowIntro] = useState(true);
  useEffect(() => {
    // Curtain plays once per session
    if (typeof window === "undefined") return;
    if (sessionStorage.getItem("msme_intro_played")) {
      setShowIntro(false);
      return;
    }
    const t = setTimeout(() => {
      sessionStorage.setItem("msme_intro_played", "1");
      setShowIntro(false);
    }, 2100);
    return () => clearTimeout(t);
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        {showIntro && <IntroCurtain />}
        <AnimatedRoutes />
      </BrowserRouter>
    </div>
  );
}

export default App;
